<!--表格组件-->
<template>
  <div>
    <!--自定义功能start-->
    <div class="flex ticketTitle" v-if='showTitle'>
      <span style="font-weight:bold">{{tableName}}<span style="color: #F56C6C;font-weight:bold">{{tableNames}}</span></span>

      <span class="green cursor" v-if="showCustomizeTableTitle" @click="customSettings">自定义列表设置</span>
      <slot name="titleRightContent"></slot>
    </div>
    <!--自定义功能end-->
    <!--table-->
    <el-table border :data="tableData" :empty-text="emptyText" :show-summary="showSummary" @sort-change="sortChange" @expand-change="expandChange" :row-key="getRowKeys" :expand-row-keys="expandsAAA" @selection-change="handleSelectionChange">
      <el-table-column type="expand" v-if="expand">
        <template slot-scope="props">
          <slot name="expand" :row="props.row" :$index="props.$index"></slot>
        </template>
      </el-table-column>
      <!--该列不为自定义start(customeTemplate值为false)-->
      <el-table-column v-for="(item, index) in choiceTitle" align="center" v-if="item.customeTemplate === false" :type="item.type" :prop="item.name" :label="item.title" :key="index" :min-width="item.minWidth" :width="item.width" :sortable="item.sort" :selectable="selectInit"></el-table-column>
      <!--该列不为自定义end-->
      <!--该列为自定义start(customeTemplate值为true)-->
      <el-table-column v-else :label="item.title" align="center" :key="index" :min-width="item.minWidth" :width="item.width" :sortable="item.sort">
        <template slot-scope="scope">
          <!--以'type'识别为哪列-->
          <!--该列为序号-->
          <div v-if="item.type === 'No'">{{scope.$index + 1}}</div>
          <!--该列为icon数组-->
          <div v-if="item.type === 'icon'"><span v-for="(icon, index) in item.options" :key="index"><i :class="icon.value"></i></span></div>
          <!--该列为switch-->
          <div v-if="item.type === 'switch'">
            <el-switch v-model="scope.row[item.name]" :active-color="item.activeColor" :active-value="item.activeValue" :inactive-value="item.inactiveValue" @change="switchChange(scope, item)"></el-switch>
          </div>
          <!--该列为鼠标滑动有事件-->
          <div v-if="item.type === 'hover' || item.type === 'button'"><slot name="hover" :button="item.name" :row="scope.row"></slot></div>
          <!--该列为操作按钮-->
          <div v-if="item.type === 'operating'"><slot name="operating" :button="item.options" :row="scope.row" :$index="scope.$index"></slot></div>
          <!--该列为将html格式显示为text-->
          <div v-if="item.type === 'html'" v-html="scope.row[item.name]"></div>
          <!--该列为多个text字段(数组)显示,(unit)为单位-->
          <div v-if="item.type ==='text'" v-for="(text, index) in item.options" :key="index">{{scope.row[text.name]}}{{text.unit}}</div>
          <!--该列为image-->
          <div v-if="item.type === 'image'"><img :src="scope.row[item.name]" :style="item.style"></div>
          <div v-if="item.type === 'click'"><el-button type="text" @click="clickCallBack(scope, item)" :disabled="scope.row[item.name] === 0">[{{scope.row[item.name]}}]</el-button></div>
          <!--该列为不同状态下显示不同-->
          <div v-if="item.type === 'moreData'"><slot name="moreData" :row="scope.row"></slot></div>
          <div v-if="item.type === 'rate'">
            <el-rate
              v-model="scope.row[item.name]"
              disabled
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              score-template="{value}">
            </el-rate>
          </div>
        </template>
      </el-table-column>
      <!--该列如果为自定义end-->
    </el-table>
    <!--自定义弹框start-->
    <el-dialog class="dialog-orderFileds" title="自定义列表设置" :visible.sync="dialogVisible" :before-close="handlerClose">
      <div class="dialog-title">已选择信息</div>
      <el-tag v-for="tag in chooseTags" v-if="tag.type !== 'operating'" :key="tag.key" :type="tag.type">{{tag.title}}</el-tag>
      <div class="dialog-title">可选择信息</div>
      <el-checkbox-group size="small" v-model="checkboxGroup2" @change="change">
        <el-checkbox-button v-for="button in cacheTableTitle" v-if="button.type !== 'operating'" :key="button.key" :label="button.key">{{button.title}}</el-checkbox-button>
      </el-checkbox-group>
      <div class="textAlign">
        <el-button @click="confirm">确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!--自定义弹框end-->
  </div>
</template>

<script>
/*
  @author: zhengxiaobei
  @date: 2018/06/xx
  @dec: 表格组件
  @params:
    tableTitle: 表格标题字段
    tableData: 表格数据
    tableName: 表格名字
    expand: 是否有展开功能
    showTitle: 是否显示表格总标题
    showCustomizeTableTitle: 是否显示表格自定义功能
*/
import _ from 'lodash'

export default {
  name: 'w-table',
  props: {
    tableTitle: Object,
    tableData: Array,
    tableName: String,
    tableNames: String,
    emptyText: String,
    expand: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    showCustomizeTableTitle: {
      type: Boolean,
      default: false
    },
    expands: {
      type: Array,
      default: () => {
        return []
      }
    },
    showSummary: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false, // 自定义弹框
      cacheTableTitle: {}, // 缓存所有标题字段
      choiceTitle: this.tableTitle, // 已选择的标题字段
      checkboxGroup2: [], // 选中列字段整合(数组)
      chooseTags: [], // 选中列整合(object)
      expandsAAA: this.expands,
      arr: []
    }
  },
  methods: {
    sortChange (obj) {
      // 排序时，需要调用后台接口时 调用
      this.$emit('sortChange', obj)
    },
    customSettings () { // 自定义弹框显示
      this.dialogVisible = true
    },
    handlerClose () { // 自定义弹框隐藏
      this.dialogVisible = false
    },
    change () { // 自定义弹框选中列改变事件
      this.chooseTags = _.pick(this.cacheTableTitle, this.checkboxGroup2) // (object)总列里筛选出选中项
      this.chooseTags['operating'] = this.cacheTableTitle.operating // 添加操作列
    },
    confirm () {
      if (Object.keys(this.chooseTags).length <= 2) { // 最少选中项为2（不包含操作列）
        this.$message({ message: '最少选择两项', type: 'warning' })
        return
      }
      this.choiceTitle = this.chooseTags // 将选中列赋值给table标题
      this.dialogVisible = false
    },
    cancel () {
      this.dialogVisible = false
    },
    switchChange (scope, item) { // switch事件子传父
      this.$emit('switchChange', scope, item)
    },
    clickCallBack (scope, item) {
      this.$emit('clickCallBack', scope, item)
    },
    inverseElection () {},
    handleSelectionChange (val) {
      this.$emit('callbackSelection', val)
    },
    expandChange (row, expandedRows) {
      this.$emit('expandChangeCallback', row, expandedRows)
    },
    getRowKeys (row) {
      return row.id
    },
    // 返回初始化某行不可选中
    selectInit (row, index) {
      return row.selectionChecked === undefined ? true : row.selectionChecked
    }
  },
  created () {
    this.choiceTitle = this.tableTitle
    if (this.showCustomizeTableTitle) {
      this.cacheTableTitle = this.tableTitle
      _.map(this.cacheTableTitle, (item, index) => {
        if (item.type !== 'operating') {
          this.checkboxGroup2.push(item.key)
        }
      })
      this.chooseTags = _.pick(this.cacheTableTitle, this.checkboxGroup2)
      this.chooseTags['operating'] = this.cacheTableTitle.operating
    }
  },
  watch: {
    'tableTitle': {
      handler: function (v, ov) {
        this.choiceTitle = v
      },
      deep: true
    },
    'tableData': {
      handler: function (v, ov) {
        this.tableData = v
      },
      deep: true
    },
    'tableName': {
      handler: function (v, ov) {
        this.tableName = v
      },
      deep: true
    },
    'showTitle': {
      handler: function (v, ov) {
        this.showTitle = v
      },
      deep: true
    },
    expands (v, ov) {
      this.expandsAAA = v
    }
  }
}
</script>

<style>
  .dialog-orderFileds .el-checkbox-group {
    margin-bottom: 50px;
  }
  .el-tag, .el-checkbox-button {
    margin: 0 10px 10px 0;
  }
  .dialog-orderFileds .el-checkbox-button__inner {
    border-left: 1px solid #dcdfe6;
  }
  .dialog-orderFileds .dialog-title {
    margin: 20px 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #ECEEF5;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/table.vue